<style scoped>
  .project-plan-details-overlay {
    min-height:480px;
  }
</style>
<template>
  <div>
    <UnavailablePageModal
      v-if="project"
      pageName="Plan Details"
      :project="project"
      :projectId="project.id"
    />
    <b-alert
      :show="dismissPlanDetailsSaveSuccessAlert"
      dismissible
      variant="success"
      @dismissed="dismissPlanDetailsSaveSuccessAlert=0"
      @dismiss-count-down="dismissPlanDetailsSaveSuccessAlertChanged"
    >
      <span>Plan Details were successfully saved</span>
    </b-alert>
    <div class="section-header">
      <div class="row bold-title">
        <div class="col">
          Plan Details
        </div>
        <div class="col right-col">
          <b-button
            v-if="isEditable"
            pill
            variant="primary"
            size="sm"
            class="submit-form-button"
            @click="savePlan"
            :disabled="!planDetailsValid"
          >
            <span>Save</span>
          </b-button>
        </div>
      </div>
    </div>
    <b-overlay
      :show="planDetailsLoading || !isEditable"
      class='project-plan-details-overlay'
      opacity=".33">
      <VueFormGenerator
        v-if="!planDetailsLoading"
        :schema="planDetailsSchema"
        :model="currentPlanDetails"
        :options="formOptions"
        @validated="modelValidated"
      />
      <template v-slot:overlay>
        <div></div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import exitFormModal from '@/mixins/exitFormModal';
import ProjectSchemaHelper from '@/mixins/projectSchemaHelper';
import ProjectApprovalMembershipManager from '@/mixins/projectApprovalMembershipManager';
import UnavailablePageModal from '@/components/common/UnavailablePageModal.vue';

export default {
  name: 'PlanDetails',
  components: {
    UnavailablePageModal,
  },
  mixins: [ProjectSchemaHelper, ProjectApprovalMembershipManager, exitFormModal],
  computed: {
    ...mapState('Project', {
      currentPlanDetails: (state) => state.currentPlanDetails,
      planDetailsLoading: (state) => state.planDetailsLoading,
    }),
  },
  data() {
    return {
      id: null,
      dismissPlanDetailsSaveSuccessAlert: 0,
      formOptions: {
        validateAfterChanged: true,
        validateAfterLoad: false,
      },
      planDetailsSchema: null,
      planDetailsValid: true,
    };
  },
  mounted() {
    this.$store.dispatch('Project/setPlanDetailsLoading', true);
    this.$store.dispatch('Project/getProject', parseInt(this.$route.params.id, 10))
      .then(() => {
        this.$store.dispatch('Project/fetchPlanDetails', parseInt(this.$route.params.id, 10))
          .then(() => {
            this.$store.dispatch('Project/setPlanDetailsLoading', false);
          });
      });
    this.planDetailsSchema = this.getPlanDetails();
  },
  methods: {
    savePlan() {
      this.$store.dispatch('Project/savePlanDetails', this.currentPlanDetails)
        .then(() => {
          this.modelSaved();
          this.$store.dispatch('Project/setPlanDetailsLoading', true);
          this.$store.dispatch('Project/fetchPlanDetails', parseInt(this.$route.params.id, 10)).then(() => {
            this.$store.dispatch('Project/setPlanDetailsLoading', false);
            this.showPlanDetailsSaveSuccessAlert();
          });
        });
    },
    showPlanDetailsSaveSuccessAlert() {
      this.dismissPlanDetailsSaveSuccessAlert = 5;
    },
    dismissPlanDetailsSaveSuccessAlertChanged(value) {
      this.dismissPlanDetailsSaveSuccessAlert = value;
    },
    modelValidated(isValid) {
      this.planDetailsValid = isValid;
    },
    validatePlanDetailsNarrative(narrative) {
      let valid = true;
      const div = document.createElement('div');
      div.innerHTML = narrative;
      if ((div.textContent.length > 0) && (div.textContent.length < 5)) {
        valid = false;
      }
      return valid;
    },
  },
};
</script>
